import React from 'react'
import classnames from 'classnames/bind'
import { PopupTooltip } from '../../overlays'
import { ColorHash } from '../../../utils'
import styles from './styles.scss'

const cx = classnames.bind(styles)

const colorHash = new ColorHash()

interface InitialsAvatarProps {
  initials: string
  size?: 'small' | 'medium' | 'large'
  backgroundColor?: string
  identifier?: string
  tooltipContent?: React.ReactNode
  onClick?: () => void
  className?: string
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({
  initials,
  size = 'medium',
  backgroundColor,
  identifier,
  tooltipContent,
  onClick,
  className,
}) => {
  const avatarClasses = cx(
    'initials-avatar',
    size,
    { clickable: !!onClick },
    className
  )

  const avatarStyle: React.CSSProperties = {
    backgroundColor:
      backgroundColor || (identifier ? colorHash.hex(identifier) : '#6c757d'),
    cursor: onClick ? 'pointer' : 'default',
  }

  const avatar = (
    <div
      className={avatarClasses}
      style={avatarStyle}
      aria-label={tooltipContent ? `Avatar for ${initials}` : initials}
      data-elm-id={`initials-avatar-${initials}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {initials}
    </div>
  )

  return tooltipContent ? (
    // @ts-ignore next
    <PopupTooltip trigger={avatar} position='top center' hoverable hideOnScroll>
      <div className={cx('tooltip-content')}>{tooltipContent}</div>
    </PopupTooltip>
  ) : (
    avatar
  )
}

export default InitialsAvatar
